import React from 'react';
import { useTranslation } from 'react-i18next';
import CardWrapper from 'components/Card/CardWrapper';

import CardBody from '../Card/CardBody';
import GridContainer from '../Grid/GridContainer';
import InfoBanner from './InfoBanner';

const InfoBannerCard = ({ title, ...props }) => {
  const { t } = useTranslation();

  return (
    <CardWrapper title={title && t('cms.infoBanner')}>
      <CardBody>
        <GridContainer>
          <InfoBanner {...props} />
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default InfoBannerCard;
